import G from "./Glob.mjs";

/**
 * @private
 * @type {true|undefined}
 */
let setupDone;

/**
 * Setup, performed only once
 * @return {Promise<boolean>}
 */
export const appBootstrapSetup = () => {
	return new Promise((resolve) => {
		if ( setupDone ) return resolve(setupDone);
		// const isDeploy = ( process.env.NODE_ENV === "production" );
		const u = window.location.pathname.slice(1).replace(/[#/].*$/,'');
		G.setupApp({
			homePage: 'Home',
			appRootNode: 'appRootNode',
			keyApplicationName: 'Home-Oli',
			usernameKey: 'user',
			localpath: u+'/',
			uri : {
				server: process.env.REACT_APP_WEB_SERVER,
				api: process.env.REACT_APP_BACKEND
			}
		});
		// window.glob.fetch = async () => ([]);
		// window.glob.lastFetched = () => ([]);
		resolve(setupDone = true);
	});
}

if ( ! setupDone ) setTimeout( appBootstrapSetup );

export default appBootstrapSetup;
